import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=f8f56948&scoped=true&"
import script from "./PropertyPanel.vue?vue&type=script&lang=js&"
export * from "./PropertyPanel.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=f8f56948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f56948",
  null
  
)

export default component.exports